export const API_BASE_URL = "https://your-api-url.com/";

export const TOKEN_NAME = "TOKEN";
